// =============================================================================
// Grid Constants - Costanti per la griglia dello scheduler
// =============================================================================

export const DEFAULT_GRID_START_HOUR = 8;
export const DEFAULT_GRID_END_HOUR = 20;
export const ROW_HEIGHT = 64;

export const SERVICE_FALLBACK_COLORS = [
  '#3B82F6', '#10B981', '#F59E0B', '#EF4444',
  '#8B5CF6', '#EC4899', '#14B8A6', '#F97316',
];

/** Offsets quarti d'ora per ogni cella */
export const QUARTER_OFFSETS = [0, 15, 30, 45] as const;
